import { MAIN_CONTEXT } from "../../constants";
import { ALERT_VARIANT, RTMS_CONTENT } from "./alertModal.constants";

// Maps a variant name + its callbacks/params to { title, message, actions }. Every alert/error
// popup in the app is one of these; add a case here rather than creating a new modal component.
export const resolveVariant = (variant, p) => {
  switch (variant) {
    case ALERT_VARIANT.COMMON_ERROR:
      return {
        title: "Server not responding",
        message: "Try again later.",
        actions: [{ label: "Close", onClick: p.onClose, minWidth: "194px" }],
      };
    case ALERT_VARIANT.SERVER_NOT_RESPONDING:
      return {
        title: "Server not responding",
        message:
          p.context === MAIN_CONTEXT.TRANSCRIBE
            ? "Transcribing meeting isn't available now."
            : "Summarizing meeting isn't available now.",
        actions: [{ label: "OK", onClick: p.onClose, minWidth: "194px" }],
      };
    case ALERT_VARIANT.AUTO_START_FAILED:
      return {
        title: "Server not responding",
        message: 'Click "Start" to begin manually.',
        actions: [
          { label: "Cancel", type: "link", onClick: p.onCancel },
          { label: "Start", onClick: p.onStart, minWidth: "100px" },
        ],
      };
    case ALERT_VARIANT.AIMS_TIMEOUT:
      return {
        title: "Getting ready",
        message: 'Click "Refresh" in 1 min.',
        actions: [{ label: "Refresh", onClick: () => window.location.reload(), minWidth: "194px" }],
      };
    case ALERT_VARIANT.RTMS_ERROR: {
      const c = RTMS_CONTENT[p.context || "summarize"]?.[p.errorType] || {};
      return {
        title: [c.title, c.title2].filter(Boolean),
        message: [c.description, c.description2, c.description3].filter(Boolean),
        actions: [
          { label: "Cancel", type: "link", onClick: p.onCancel, minWidth: "88px" },
          { label: "Restart", onClick: p.onRestart, minWidth: "88px" },
        ],
      };
    }
    default:
      return {};
  }
};
